import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import "./Album.css";
import axios from "axios";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import DonationFormComponent from "../components/DonationFormComponent";
import PlayListComponent from "../components/PlayListComponent";
import Loader from "react-loader-spinner";
import { withAlert } from "react-alert";

class AlbumDetails extends Component {
  state = {
    album: {},
    loading: true,
    error: false,
    download: false,
    message: "",
  };

  componentDidMount() {
    const { handle } = this.props.match.params;

    axios
      .get(`/v1/api/album/${handle}`)
      .then((res) => this.setState({ album: res.data, loading: false }))
      .catch((err) => {
        console.error("Album detail API failed:", err);
        this.setState({ error: true, loading: false });
      });
  }

  alert = this.props.alert;

  download = (msg) => {
    this.setState({ download: true, message: msg });
    this.alert.show(
      <div>
        <div>{msg}</div>
      </div>,
      {
        timeout: 5000,
        type: "success",
      }
    );
  };

  render() {
    const { album, loading, error, download } = this.state;

    return (
      <div className="App">
        <Header />

        <Banner
          page={album.title || "Album"}
          pageName="Songs"
          middlePage="Album"
          middleLink="/album"
        />

        <section className="fsm-section fsm-album-detail">
          <div className="container">
            {loading && (
              <div className="fsm-loader">
                <Loader
                  type="TailSpin"
                  color="#E32227"
                  height={70}
                  width={70}
                />
              </div>
            )}

            {error && !loading && (
              <div className="fsm-empty-state">
                <h3>Unable to load album</h3>
                <p>Please check your connection and try again.</p>
                <Link to="/album" className="fsm-btn fsm-btn-primary">
                  Back to Albums
                </Link>
              </div>
            )}

            {!loading && !error && album.id && (
              <div className="fsm-album-detail-grid">
                {/* LEFT: Album cover + info */}
                <aside className="fsm-album-detail-card">
                  <div className="fsm-album-detail-cover">
                    <img src={album.image} alt={album.title} />
                  </div>

                  <h1>{album.title}</h1>

                  <div className="fsm-album-detail-meta">
                    <span>
                      {album.songs_no}{" "}
                      {album.songs_no === "1" ? "track" : "tracks"}
                    </span>
                    {album.copyright && (
                      <>
                        <span className="fsm-album-meta-dot">•</span>
                        <span>{album.copyright}</span>
                      </>
                    )}
                  </div>

                  {album.dedication && (
                    <div className="fsm-album-detail-section">
                      <h4>Dedication</h4>
                      <p>{album.dedication}</p>
                    </div>
                  )}

                  {album.acknoledgement && (
                    <div className="fsm-album-detail-section">
                      <h4>Acknowledgement</h4>
                      <p>{album.acknoledgement}</p>
                    </div>
                  )}

                  <Link to="/album" className="fsm-album-back">
                    ← Back to Albums
                  </Link>
                </aside>

                {/* RIGHT: Player or Donation Form */}
                <div className="fsm-album-detail-main">
                  <div className="fsm-album-detail-player">
                    <h2>Tracklist</h2>

                    {album.enable_donation && !download ? (
                      <DonationFormComponent
                        donationMessage={album.donation_message}
                        parentFunction={this.download}
                        albumID={album.id}
                      />
                    ) : (
                      <PlayListComponent media={album.media} />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default withAlert()(AlbumDetails);